/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classname from 'classnames';
import { observer } from 'mobx-react';

import * as React from 'react';

import { ICittaProductEoqData } from './citta-product-eoq.data';
import { ICittaProductEoqProps } from './citta-product-eoq.props.autogenerated';

export interface ICittaProductEoqViewProps extends ICittaProductEoqProps<ICittaProductEoqData> {
    EoqContainer: IModuleProps
    QuantityTitleTextNode: INodeProps;
    AvailableTitleTextNode: INodeProps;
    QuantityNode: INodeProps;
    AvailableNode: INodeProps;
}

/**
 *
 * CittaProductEoq component
 * @extends {React.PureComponent<ICittaProductEoqProps<ICittaProductEoqData>>}
 */
 @observer
class CittaProductEoq extends React.PureComponent<ICittaProductEoqProps<ICittaProductEoqData>> {
    public render(): JSX.Element | null {

        let content: ICittaProductEoqData;

        try {
            content = this.props.data;
        } catch(e) {
            this.props.telemetry.error(`Something went wrong -----${e}`);
            return null;
        }
        
        const availableQuantity = content.productAvailability
            && content.productAvailability.result && content.productAvailability.result[0] && 
            // @ts-ignore
            content.productAvailability.result[0].ProductAvailableQuantity.AvailableQuantity

        const productEOQ = content.attributes.result && content.attributes.result.find(att => att.Name === "EOQ");
        const quantityTitleText = this.props.config && this.props.config.quantityTitleText ? this.props.config.quantityTitleText : 'Order Quantity:';
        const availableTitleText = this.props.config && this.props.config.availableTitleText ? this.props.config.availableTitleText : 'Available:';

        const className = this.props.config && this.props.config.className ? this.props.config.className : '';
        if (productEOQ) {
            const productEoqViewProps: ICittaProductEoqViewProps = {
                ...(this.props as ICittaProductEoqProps<ICittaProductEoqData>),
                EoqContainer: {
                    moduleProps: this.props,
                    className: classname('product-eoq', className),
                },
                QuantityTitleTextNode: {
                    className: 'product-quantity-title',
                    children: quantityTitleText
                },
                AvailableTitleTextNode: {
                    className: 'product-available-title',
                    children: availableTitleText
                },
                QuantityNode: {
                    className: 'product-quantity-id',
                    children: productEOQ.TextValue
                },
                AvailableNode: {
                    className: 'product-available-id',
                    children: availableQuantity || '0'
                },
            };
            return this.props.renderView(productEoqViewProps) as React.ReactElement;
        }
        return null;
    }
}

export default CittaProductEoq;
